<!-- modal escoger -->
<template>
  <div class="text-center">
    <v-dialog v-model="dialog" class="full-width" persistent scrollable>
      <v-card class="oe-card">
        <v-card-title class="oe-hero py-3">
          <div class="d-flex align-center justify-space-between" style="width: 100%;">
            <div class="d-flex align-center" style="gap: 12px;">
              <v-avatar color="white" size="40" class="elevation-1">
                <v-icon color="teal darken-3">mdi-book-open-variant</v-icon>
              </v-avatar>
              <div>
                <div class="text-h6 white--text">Programas para oferta académica</div>
                <div class="text-body-2 white--text">
                  Selecciona programas universidad a nivel nacional para todas las sedes
                </div>
              </div>
            </div>
            <v-chip color="teal lighten-5" class="teal--text text--darken-3" small>
              Seleccionados: {{ seleccionados.length }}
            </v-chip>
          </div>
        </v-card-title>

        <v-card-text class="pt-2">
          <v-divider class="mb-4" />
          <v-row dense>
            <v-col cols="12" md="6">
              <v-card outlined class="pa-3">
                <div class="text-subtitle-2 mb-2">Datos de la oferta</div>
                <v-row dense>
                  <v-col cols="12">
                    <v-text-field
                      label="* Nombre de la oferta académica"
                      v-model.trim="input.nombre_oferta"
                      dense
                      outlined
                      prepend-icon="mdi-file"
                      type="text"
                      placeholder="Ej. Oferta 2026-I"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      :items="xmeses"
                      v-model="input.mes"
                      label="* Mes de la oferta"
                      item-value="id"
                      dense
                      outlined
                      prepend-icon="mdi-calendar"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      label="* Año de la oferta"
                      v-model.number="input.anio"
                      dense
                      outlined
                      prepend-icon="mdi-calendar"
                      type="number"
                    />
                  </v-col>
                </v-row>
              </v-card>

              <v-card outlined class="pa-3 mt-3">
                <div class="d-flex align-center justify-space-between mb-2">
                  <div class="text-subtitle-2">Programas universidad seleccionados</div>
                  <v-chip x-small color="teal lighten-5" class="teal--text text--darken-3">
                    {{ seleccionados.length }} items
                  </v-chip>
                </div>
                <v-data-table
                  :headers="xheaders_punis"
                  :items="seleccionados"
                  item-key="id"
                  disable-pagination
                  hide-default-footer
                  dense
                  class="elevation-1"
                  no-data-text="No hay programas seleccionados"
                >
                  <template v-slot:item.estado="{ item }">
                    <v-chip x-small :color="item.estado === 'inscrito' ? 'green' : 'orange'" dark>
                      {{ item.estado }}
                    </v-chip>
                  </template>
                  <template v-slot:item.programas="{ item }">
                    <v-chip x-small color="teal lighten-5" class="teal--text text--darken-3" @click="$refs.refmodalVerProgs_esam.openmodal(item)">
                      {{ item.programas ? item.programas.length : 0 }}
                    </v-chip>
                  </template>
                  <template v-slot:item.ultimoModuloEnCurso="{ item }">
                    <template v-if="ultimoModuloEnCurso(item)">
                      <div class="caption font-weight-medium">
                        MOD {{ ultimoModuloEnCurso(item).numero }}
                      </div>
                      <div class="caption grey--text text--darken-1">
                        {{ ultimoModuloEnCurso(item).nombre }}
                      </div>
                    </template>
                    <span v-else class="caption grey--text">-</span>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>

            <v-col cols="12" md="6"> 
              <v-card outlined class="pa-3" tile>
                <v-select
                  :items="convenios"
                  v-model="$store.state.convenio"
                  :disabled="false"
                  item-text="nombre"
                  item-value="id" 
                  label="Convenio de los programas esam:"
                  outlined
                  dense
                  placeholder="Seleccione..."
                  hide-details 
                  return-object />

                <div class="d-flex align-center justify-space-between mb-2">
                  <!-- <div class="text-subtitle-2 mt-2">Buscar programas universidad:</div> -->
                  <div class="text-subtitle-2 mt-2"> </div>
                  <v-btn text small :loading="loading_progs" @click="listar_programas_universidad()">
                    Actualizar
                  </v-btn>
                </div>
                <v-text-field
                  v-model="search_programa"
                  append-icon="mdi-magnify"
                  prepend-inner-icon="mdi-filter-variant"
                  label="Buscar programas universidad"
                  clearable 
                  outlined
                  dense
                  class="search-field"
                  hide-details="auto"
                  @keyup.enter="listar_programas_universidad()"
                  @click:append="listar_programas_universidad()"
                />
                <v-data-table
                  v-model="seleccionados"
                  :headers="xheaders_punis"
                  :items="programas_uni"
                  :loading="loading_progs"
                  item-key="id"
                  show-select
                  selectable-key="_seleccion_habilitada"
                  disable-pagination
                  hide-default-footer
                  dense
                  class="elevation-1"
                  no-data-text="No hay resultados"
                >
                  <template v-slot:item.programaNombre="{ item }">
                    <div>
                      <div>{{ item.programaNombre }}</div>
                      <div class="caption grey--text">{{ item.areaUniversidad.nombre }}</div>
                      <div v-if="programaSeleccionDeshabilitada(item)" class="caption red--text text--darken-2">
                        {{ motivoProgramaNoSeleccionable(item) }}
                      </div>
                    </div>
                  </template>
                  <template v-slot:item.programas="{ item }">
                    <v-chip x-small color="teal lighten-5" class="teal--text text--darken-3" @click="$refs.refmodalVerProgs_esam.openmodal(item)">
                      {{ item.programas ? item.programas.length : 0 }}
                    </v-chip>
                  </template>
                  <template v-slot:item.ultimoModuloEnCurso="{ item }">
                    <template v-if="ultimoModuloEnCurso(item)">
                      <div class="caption font-weight-medium">
                        MOD {{ ultimoModuloEnCurso(item).numero }}
                      </div>
                      <div class="caption grey--text text--darken-1">
                        {{ ultimoModuloEnCurso(item).nombre }}
                      </div>
                    </template>
                    <span v-else class="caption grey--text">-</span>
                  </template>
                  <template v-slot:item.ceubArchivoId="{ item }">
                    <v-chip x-small :color="item.ceubArchivoId ? 'teal darken-2' : 'grey lighten-1'" :dark="!!item.ceubArchivoId">
                      {{ item.ceubArchivoId ? 'si' : 'no' }}
                    </v-chip>
                  </template>
                  <template v-slot:item.estado="{ item }">
                    <v-chip x-small :color="item.estado === 'inscrito' ? 'green' : 'orange'" dark>
                      {{ item.estado }}
                    </v-chip>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-btn color="teal" text @click="$refs.modalListaEscogidos.openmodal()">
            <v-icon left small>mdi-history</v-icon>
            Ver historial
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="cerrar()">Cerrar</v-btn>
          <v-btn color="teal darken-2" class="white--text" :loading="loading" @click="enviar()">
            <v-icon left small>mdi-content-save</v-icon>
            Guardar selección
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <modal-confirmar-escoger ref="modalConfirmarEscoger" />
    <modal-lista-escogidos ref="modalListaEscogidos" />
    <modalVerProgs_esam ref="refmodalVerProgs_esam" />
  </div>
</template>

<script> 
import {meses,headers_punis} from './utils';
import ProgramaUniversidadService from '../../pagos/services/programa-universidad.service';
import modalConfirmarEscoger from './modal-confirmar-escoger.vue';
import modalListaEscogidos from './modal-lista-escogidos.vue';
import modalVerProgs_esam from './modal-ver-progs_esam.vue';
import gql from 'graphql-tag';

const VALIDAR_MODULO_MAXIMO_PROGRAMAS = true;
const MODULO_MAXIMO_DIPLOMADO = 3;
const MODULO_MAXIMO_MAESTRIA = 7;

  export default {
    components: { modalConfirmarEscoger, modalListaEscogidos,modalVerProgs_esam },
    data() {
      return {
        loading: true,
        loading_progs: false,
        dialog: false,  
        programas_uni: [],
        seleccionados: [],
        xheaders_punis: [],
        xmeses: [],
        convenios:[],
        search_programa: '',
        input:{
            nombre_oferta:'',
            mes: null,
            anio: new Date().getFullYear(),
        }
      };
    },
    computed: {
    },
    watch:{
      '$store.state.convenio': function(){
        this.listar_programas_universidad();
      }
    },
    methods: {
      mesTexto(mesId) {
        const m = this.xmeses.find(x => x.id === mesId);
        return m ? m.text : mesId;
      },
      async openmodal() {  
        this.loading = false;
        this.dialog = true;
        this.seleccionados = []
        this.input.nombre_oferta = '';
        this.input.mes = new Date().getMonth();
        this.search_programa = ''
        this.input.anio = new Date().getFullYear();
        this.xmeses = meses();
        this.xheaders_punis = headers_punis();

        this.listar_programas_universidad();
        this.getConveniosUniversidades();
      },
      async listar_programas_universidad() {
        const opciones = { params:{estado:'pendiente'} }
        if(this.search_programa) opciones.params.busqueda = this.search_programa;
        if(this.$store.state.convenio) opciones.params.universidadId = this.$store.state.convenio.id;

        this.loading_progs = true;
        const res = await ProgramaUniversidadService.findAllPaginado(opciones)
        this.loading_progs = false;
        // window.console.log('resss',res);
        this.programas_uni = (res.data.datos || []).map(this.prepararProgramaUniversidadSeleccion);
        this.seleccionados = this.seleccionados.filter(s => !this.programaSeleccionDeshabilitada(s));
        
      },
      prepararProgramaUniversidadSeleccion(programaUniversidad) {
        const deshabilitada = this.programaSeleccionDeshabilitada(programaUniversidad);
        return {
          ...programaUniversidad,
          _seleccion_habilitada: !deshabilitada,
        };
      },
      normalizarTexto(value) {
        return String(value || '')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase();
      },
      tipoPostgradoPorNombre(programaUniversidad) {
        const nombre = this.normalizarTexto(programaUniversidad?.programaNombre || programaUniversidad?.nombreCompuesto);
        if (nombre.includes('diplomado')) return 'diplomado';
        if (nombre.includes('maestria')) return 'maestria';
        return null;
      },
      moduloMaximoPermitido(programaUniversidad) {
        const tipo = this.tipoPostgradoPorNombre(programaUniversidad);
        if (tipo === 'diplomado') return MODULO_MAXIMO_DIPLOMADO;
        if (tipo === 'maestria') return MODULO_MAXIMO_MAESTRIA;
        return null;
      },
      numeroUltimoModuloConInscripciones(programa) {
        const numero = Number(programa?.ultimoProgramaModuloConInscripciones?.numero);
        return Number.isFinite(numero) ? numero : 0;
      },
      ultimoModuloEnCurso(programaUniversidad) {
        const programa = (programaUniversidad?.programas || [])
          .filter(item => item?.ultimoProgramaModuloConInscripciones)
          .sort((a, b) => (
            this.numeroUltimoModuloConInscripciones(b) -
            this.numeroUltimoModuloConInscripciones(a)
          ))[0];
        if (!programa) return null;

        const ultimoModulo = programa.ultimoProgramaModuloConInscripciones;
        return {
          numero: ultimoModulo.numero,
          nombre: ultimoModulo.modulo?.nombre || '',
        };
      },
      programaFueraDeRegla(programaUniversidad) {
        if (!VALIDAR_MODULO_MAXIMO_PROGRAMAS) return null;

        const maximo = this.moduloMaximoPermitido(programaUniversidad);
        if (!maximo) return null;

        return (programaUniversidad?.programas || [])
          .find(programa => this.numeroUltimoModuloConInscripciones(programa) > maximo) || null;
      },
      programaSeleccionDeshabilitada(programaUniversidad) {
        return !!this.programaFueraDeRegla(programaUniversidad);
      },
      motivoProgramaNoSeleccionable(programaUniversidad) {
        const programa = this.programaFueraDeRegla(programaUniversidad);
        const maximo = this.moduloMaximoPermitido(programaUniversidad);
        if (!programa || !maximo) return '';

        const modulo = this.numeroUltimoModuloConInscripciones(programa);
        const tipo = this.tipoPostgradoPorNombre(programaUniversidad);
        return `No seleccionable: ${tipo} con programa existente en módulo ${modulo}. Máximo permitido: ${maximo}`;
      },
      async getConveniosUniversidades() {
        const sql = gql`query{ getInstituciones(estado:true){id,nombre,tipo,convenio,abreviatura} }`;
        const data = await this.$apollo.query({ query: sql }).then(({ data }) => data);
        const conves = data.getInstituciones.filter(x=>x.convenio);
        this.convenios = conves; 
      },
      cerrar() {
        this.dialog = false;
      },
      
      async enviar() {
        const userid = this.$store.state.DATA_USER.id;
        const rol = this.$store.state.CARGO.id;
        // Castillo Rospilloza Elio Diego
        // Vaca Prado Valeria Del Rosario
        // Guzman Amelia
        // López Tapia Juan Ángel
        // marcia vargas
        const permitidos = [47129,59716,93,19467,73]

        if(rol != 1 && !permitidos.includes(userid)){
          this.$root.$notify.show('No autorizado para esta accion', {
            color: 'red',
            x: 'right',
          });
          return;
        }

        if(!this.input.nombre_oferta || !this.input.mes || !this.input.anio || this.seleccionados.length == 0) {
          this.$root.$notify.show('Complete todos los campos requeridos', {
            color: 'red',
            x: 'right',
          });
          return;
        }
        const seles = this.seleccionados.map(s=> ({
          id: s.id,
          codigo: s.codigo,
          programaNombre: s.programaNombre,
          areaUniversidad: s.areaUniversidad,
          sedeUniversidad: s.sedeUniversidad.institucion.nombre,
          estado: s.estado,
          ceubArchivoId: s.ceubArchivoId,
          programas: s.programas.map(p=>({id:p.id, codigo:p.codigo, nombreCompuesto: p.nombreCompuesto})),
        }));
        const seles_json = JSON.stringify(seles);
        const confirmar = await this.$refs.modalConfirmarEscoger.openmodal({
          oferta: {
            nombre_oferta: this.input.nombre_oferta,
            mes_texto: this.mesTexto(this.input.mes),
            anio: this.input.anio
          },
          seleccionados: seles
        });
        if(!confirmar) return;
        
        const datos = {
          seleccionados_por: this.$store.state.DATA_USER.id,
          nombre_oferta:this.input.nombre_oferta,
          mes: this.input.mes,
          anio: this.input.anio,
          seleccionados: seles_json,
        }
        
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        
        const graphql = JSON.stringify({
          query: "mutation save_escogidos($input:NewEscogidos!){ save_escogidos(input:$input){id fecha_registro} }",
          variables: {"input":datos}
        })
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: graphql, 
        };
        
        this.loading = true;
        const res = await fetch(process.env.VUE_APP_PROYECTOS_API, requestOptions).then(r=>r.json()).then(({data})=>data).catch(e=>e)
        this.loading = false;
        window.console.log('res',res);
        if(res && res.save_escogidos){
          this.$root.$notify.show('Lista guardada', {
            color: 'green',
            x: 'right',
          });
          this.cerrar()
        }
      }, 
    },
  };
</script>

<style scoped>
.oe-card {
  border-radius: 14px;
  overflow: hidden;
}
.oe-hero {
  background: linear-gradient(120deg, #004D40 0%, #00796B 45%, #4DB6AC 100%);
}
.search-field {
  background: #f6fbfa;
  border-radius: 10px;
}
</style>
